import { ENDPOINTS } from '../constants/endpoints'
import type { AxiosResponse } from 'axios'
import type { User, UserCreateInput, UserUpdateInput } from '../types/user'
import axiosInstance from '@/integrations/axios/axios-instance'

export const usersApi = {
  getUsers: (): Promise<AxiosResponse<{ users: Array<User> }>> => {
    const endpoint = ENDPOINTS.GET_USERS
    return axiosInstance.get(endpoint)
  },
  getUser: (userId: string): Promise<AxiosResponse<{ user: User }>> => {
    const endpoint = `${ENDPOINTS.GET_USER}/${userId}`
    return axiosInstance.get(endpoint)
  },
  createUser: (
    user: UserCreateInput,
  ): Promise<AxiosResponse<{ message: string; user: User }>> => {
    const endpoint = ENDPOINTS.CREATE_USER
    return axiosInstance.post(endpoint, user)
  },
  updateUser: (
    user: UserUpdateInput,
  ): Promise<AxiosResponse<{ message: string; user: User }>> => {
    const endpoint = `${ENDPOINTS.UPDATE_USER}/${user._id}`
    return axiosInstance.put(endpoint, user)
  },
  deleteUser: (
    userId: string,
  ): Promise<AxiosResponse<{ message: string; id: string }>> => {
    const endpoint = `${ENDPOINTS.DELETE_USER}/${userId}`
    return axiosInstance.delete(endpoint)
  },
  sendUserPassword: (
    email: string,
  ): Promise<AxiosResponse<{ message: string }>> => {
    const endpoint = `${ENDPOINTS.SEND_PASSWORD_EMAIL}`
    return axiosInstance.post(endpoint, { email })
  },
  completeUserSetup: (
    token: string,
    password: string,
  ): Promise<AxiosResponse<{ message: string; user: User }>> => {
    const endpoint = `${ENDPOINTS.COMPLETE_USER_SETUP}/${token}`
    return axiosInstance.post(endpoint, { password })
  },
}
